import config from '../config.js'

let { createSaleClientRoot } = config;

export default {
    CS_PAYMENT : createSaleClientRoot +  "/confirm-details"
}